import { Injectable } from '@angular/core';
import { HttpRequestService } from '../_common/http-request.service';

@Injectable()
export class CrossPointsService {

    constructor(private http: HttpRequestService) { }

    gets(parameters) {
        console.log('cross-points-');
        return this.http.get('cross-points', parameters)
            .map(res => {
                return res.json();
            })
    }

}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_services/cross-points.service.ts